export enum Numbers {
  ZERO = '-----',
  ONE = '.----',
  TWO = '..---',
  THREE = '...--',
  FOUR = '....-',
  FIVE = '.....',
  SIX = '-....',
  SEVEN = '--...',
  EIGHT = '---..',
  NINE = '----.'
}
